module.exports = __webpack_public_path__ + "static/media/exclamation-circle-solid.d2cc5314.svg";